import React, { Component } from 'react';
import Toast, { ToastType } from './Toast/Toast';
import { DispatchProp, connect } from 'react-redux';
import { removeToast } from '@actions/toastActions';
import { ApplicationState } from '@reducers/index';

type Props = {
    toasts: ToastType[],
} & DispatchProp;

class ToastManager extends Component<Props> {
    public render() {
        return (
            <div id="toast-container" className="toast-top-right" aria-live="polite" role="alert">
                {this.props.toasts.map((toast: ToastType) => {
                    return (
                        <Toast
                            key={`toast-${toast.id}`}
                            toast={toast}
                            onTimedOut={() => {
                                this.props.dispatch(removeToast(toast));
                            }}
                        />
                    );
                })}
            </div>
        );
    }
}

const mapStateToProps = ({ toasts }: ApplicationState) => {
    return {
        toasts,
    };
};

export default connect(mapStateToProps)(ToastManager);


// WEBPACK FOOTER //
// ./src/components/ToastManager.tsx